module.exports = "/static/assets/1e37529463c1d3ad6cd386cca726a060.png";